import React from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import {useSelector, useDispatch} from "react-redux";
import { userActions } from "./store/store";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();

  const { accounts, inProgress } = useMsal();
  console.log('accounts', accounts);
  const isAuthenticated = accounts.length > 0;
  //console.log(isAuthenticated, inProgress);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  } else {
    dispatch(userActions.addUserInfo({
      user: accounts[0].name,
      username: accounts[0].username,
      userId: accounts[0].homeAccountId
    }))
    sessionStorage.setItem("user", accounts[0].name)
  }

  return children;
};

export default ProtectedRoute;
